<template>
  <vs-popup class="add-sundry-cost-popup" id="popup" :title="isCreateMode ? 'ADD ADDITIONAL COST RULE' : 'UPDATE ADDITIONAL COST RULE'"
    @close="open = false" :active.sync="open" :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form id="create-sundry-cost-popup" @submit.prevent="handleSubmit(onClickCreateCost)" autocomplete="off">

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="name" name="name" rules="required" v-slot="{ errors }">
                <small class="label">Cost Name/Description</small>
                <vs-input v-model="form.name" name="cost" class="w-full" label="" :danger="!!errors[0]"
                  :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col">
              <ValidationProvider vid="product_types" name="product_types" rules="required" v-slot="{ errors }">
                <small class="label">Product Types</small>
                <v-select name="product_types" :closeOnSelect="true" v-model="form.product_types" multiple
                  :options="['liquid', 'powder', 'spray dry powder', 'fruit']" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col">
              <ValidationProvider vid="condition" name="condition" rules="required" v-slot="{ errors }">
                <small class="label">Condition</small>
                <v-select name="condition" :closeOnSelect="true" v-model="form.condition" label="key" :reduce="option => option.value"
                  :options="condition_options" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="quantity" name="quantity" rules="required" v-slot="{ errors }">
                <small class="label">Quantity (KG)</small>
                <vs-input v-model="form.quantity" name="quantity" class="w-full" label="" :danger="!!errors[0]"
                  :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row mb-8">
            <div class="w-full vx-col">
              <ValidationProvider vid="sage_nominal_code_id" name="sage_nominal_code_id" rules="required" v-slot="{ errors }">
                <small class="label">Sage Nominal Code</small>
                <v-select name="sage_nominal_code_id" :closeOnSelect="true" v-model="form.sage_nominal_code_id" label="code" :reduce="option => option.id"
                  :options="nominal_codes" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <vs-divider> Cost amount </vs-divider>

          <div class="mb-3 vx-row mt-4" v-for="(currency, index) in form.currencies" :key="index+'currency'">
            <div class="w-2/5 vx-col">
              <ValidationProvider vid="currency" name="currency" rules="required" v-slot="{ errors }">
                <small class="label">&nbsp;</small>
                <vs-input disabled v-model="currency.currency" name="amount" class="w-full" label="" :danger="!!errors[0]"
                  :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="w-3/5 vx-col md:mb-0">
              <ValidationProvider vid="amount" name="amount" rules="required" v-slot="{ errors }">
                <small class="label">Amount in {{currency.currency}}</small>
                <vs-input v-model="currency.amount" name="amount" class="w-full" label="" :danger="!!errors[0]"
                  :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
          </div>

          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button v-can="'edit-user-type-setting'" button="submit" class="mt-2 ml-auto">Save Changes</vs-button>
            <vs-button @click="form = {}" class="mt-2 ml-4" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const StaffRepository = RepositoryFactory.get('staff')
import vSelect from 'vue-select'
const AdditionalCostRepository = RepositoryFactory.get('additional_cost')
const SageSettingsRepository = RepositoryFactory.get('sage_settings');

import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

function initialState() {
  return {
    open: false,
    id: '',
    form: {
      cost: '',
      formulation_type: '',
      note: '',
      currencies: []
    },
    isCreateMode: true,
    condition_options: [
      { key: 'equal', value: 'eq' },
      { key: 'greater-than', value: 'gt' },
      { key: 'greater-than-or-equal', value: 'gte' },
      { key: 'less-than', value: 'lt'},
      { key: 'less-than-or-equal', value: 'lte' },
    ],
    currency_list: [],
    nominal_codes: []
  }
}

export default {
  name: 'AddOrderAdditionalCostPopUp',
  data() {
    return initialState()
  },
  components: {
    'v-select': vSelect,
  },
  methods: {
    async openPopup(id) {
      try {
        Object.assign(this.$data, initialState());
        this.$refs.form.reset();
        this.open = true;
        await this.fetchCurrencyList()
        await this.fetchNominalCodes()
        if (!!id) {
          this.id = id
          this.isCreateMode = false
          await this.fetchCostDetails()
        } else {
          this.isCreateMode = true
        }
      } catch (error) {
        this.convertAndNotifyError(error);
      }
    },
    async fetchCurrencyList() {
      await this.$vs.loading({
        container: '#create-sundry-cost-popup',
        scale: 0.45
      })
     try {
       const { data } = (await StaffRepository.getCurrencyList()).data
       this.currency_list = data.map((x) => x.code)
       this.form.currencies = data.map((x) => { 
        return { currency: x.code, amount: 0 }
       })
     } catch (e) {
       this.convertAndNotifyError(e)
     }
     await this.$vs.loading.close('#create-sundry-cost-popup > .con-vs-loading')
    },
    async fetchNominalCodes() {
      try {
        const {data} = await SageSettingsRepository.getListOfSageNominalCodes(1, '', 50, 0)
        this.nominal_codes =  data.data
      } catch (error) {
        
      }
    },
    async fetchCostDetails() {
      await this.$vs.loading({
        container: '#create-sundry-cost-popup',
        scale: 0.45
      })
      try {
        const { data } = (await AdditionalCostRepository.getAdditionalCost(this.id)).data
        this.form = data
        if(this.form.currencies.length !== this.currency_list.length) {
          const missingCurrencies = this.currency_list.filter((x) => !this.form.currencies.map((x) => x.currency).includes(x))
          missingCurrencies.forEach((x) => {
            this.form.currencies.push({ currency: x, amount: 0 })
          })
        }
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#create-sundry-cost-popup > .con-vs-loading')
    },
    async onClickCreateCost() {
      const vue = this;
      await this.$vs.loading({
        container: '#create-sundry-cost-popup',
        scale: 0.45
      })
      try {
        this.form.quantity = Number(this.form.quantity).toFixed(3)
        this.form.currencies = this.form.currencies.map((x) => {
          return { currency: x.currency, amount: Number(x.amount).toFixed(2) }
        })
        if (this.isCreateMode) {
          await AdditionalCostRepository.createAdditionalCost(this.form);
          this.showSuccessMessage('Additional cost rule added!');
        } else {
          await AdditionalCostRepository.updateAdditionalCost(this.id, this.form);
          this.showSuccessMessage('Additional costrule  updated!');
        }
        await vue.$parent.refreshData();
        this.open = false;
      } catch (e) {
        this.$vs.loading.close('#create-sundry-cost-popup > .con-vs-loading')
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#create-sundry-cost-popup > .con-vs-loading')
    },
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
.add-sundry-cost-popup>>>.vs-popup {
  /*min-height: 50% !important;*/
  min-width: 25% !important;
}
</style>
